// extracted by mini-css-extract-plugin
export default {"b-icon-warning":"CaptureVisa_style_b-icon-warning__RnAGN","wrapper":"CaptureVisa_style_wrapper__pMNEk","rotate":"CaptureVisa_style_rotate__m9DoM"};